//TICKETS
export const CREATE_TICKET = 1;
export const TAKE_TICKET = 2;